import axios from 'axios';
import countryService from '../services/getCountryService';

let instance = null;

const getAxiosInstance = () => {
  if (!instance) {
    instance = axios.create();
    instance.defaults.baseURL = `${process.env.PUBLIC_URL}/api`;
    instance.interceptors.request.use((config) => {
      const countryType = countryService.getCurrentRegion();
      config.headers['X-Country'] = countryType;
      return config;
    });
  }
  return instance;
};

export default getAxiosInstance;
